import React from "react";
import styled from "styled-components";

const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  font-size: 0.7em;
`;
const InfoIcon = styled.div`
  margin-right: 2px;
  position: absolute;
  left: 3px;
  font-size: 1em;
`;
const Content = styled.div`
  display: flex;
  height: 100%;
  font-size: 1.2em;
  align-items: center;
  justify-content: center;
`;

// Same options as the sidebar's Home/Away Average Formation buttons.
export default function AverageFormation({
  item,
  previewGraphic,
  game,
  allOptaEvents,
}) {
  return (
    <Main
      onClick={() => {
        previewGraphic("AverageFormation", {
          team: game?.[item?.team + "_team"],
          opta_events: allOptaEvents,
          squads: game?.lineup?.[item?.team],
          game,
        });
      }}
    >
      <Title>
        <InfoIcon>GFX</InfoIcon>
        {game?.[item?.team + "_team"]?.short_name} Average Formation
      </Title>
      <Content>PREVIEW</Content>
    </Main>
  );
}
